export class RdsNativePitrWindow {
    'earliestRestorableTime';
    'latestRestorableTime';
    'backupRetentionDays';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "earliestRestorableTime",
            "baseName": "earliestRestorableTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "latestRestorableTime",
            "baseName": "latestRestorableTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "backupRetentionDays",
            "baseName": "backupRetentionDays",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return RdsNativePitrWindow.attributeTypeMap;
    }
    constructor() {
    }
}
